import { OfflineConfigManager } from "@amzn/amazon-config-store-type-script-offline-adapter";
import {
  MarketplaceConfigClientProvider,
  MarketplaceConfigContext,
} from "@amzn/marketplace-config-type-script-client/dist/marketplaceConfig";
import {
  CountryCodeToMarketplaceIdMapClientProvider,
  CountryCodeToMarketplaceIdMapContext,
} from "@amzn/country-code-to-marketplace-id-map-type-script-client/dist/countryCodeToMarketplaceIdMap";

import { isProdStage } from "../../util/stageUtils";

// ACS Offline Client
// See - https://w.amazon.com/bin/view/INTech/AmazonConfigStore/OfflineClient

// MarketplaceConfig Prod
import { documents as marketplaceConfigProdDocuments } from "../../amazon_config_store_offline_config/acs_MarketplaceConfig/documents.json";
import { queries as marketplaceConfigProdExactQueries } from "../../amazon_config_store_offline_config/acs_MarketplaceConfig/queries.json";
import { queries as marketplaceConfigProdHfQueries } from "../../amazon_config_store_offline_config/acs_MarketplaceConfig/hierarchical_queries.json";

// MarketplaceConfig Devo
import { documents as marketplaceConfigDevoDocuments } from "../../amazon_config_store_offline_config/devo/acs_MarketplaceConfig/documents.json";
import { queries as marketplaceConfigDevoExactQueries } from "../../amazon_config_store_offline_config/devo/acs_MarketplaceConfig/queries.json";
import { queries as marketplaceConfigDevoHfQueries } from "../../amazon_config_store_offline_config/devo/acs_MarketplaceConfig/hierarchical_queries.json";

// CountryCodeToMarketplaceId Prod
import { documents as countryCodeToMarketplaceIdProdDocuments } from "../../amazon_config_store_offline_config/acs_CountryCodeToMarketplaceIdMap/documents.json";
import { queries as countryCodeToMarketplaceIdProdExactQueries } from "../../amazon_config_store_offline_config/acs_CountryCodeToMarketplaceIdMap/queries.json";
import { queries as countryCodeToMarketplaceIdProdHfQueries } from "../../amazon_config_store_offline_config/acs_CountryCodeToMarketplaceIdMap/hierarchical_queries.json";

// CountryCodeToMarketplaceId Devo
import { documents as countryCodeToMarketplaceIdDevoDocuments } from "../../amazon_config_store_offline_config/devo/acs_CountryCodeToMarketplaceIdMap/documents.json";
import { queries as countryCodeToMarketplaceIdDevoExactQueries } from "../../amazon_config_store_offline_config/devo/acs_CountryCodeToMarketplaceIdMap/queries.json";
import { queries as countryCodeToMarketplaceIdDevoHfQueries } from "../../amazon_config_store_offline_config/devo/acs_CountryCodeToMarketplaceIdMap/hierarchical_queries.json";

const configManager = new OfflineConfigManager();

const marketplaceToCountryCodeClient = configManager.createClient(
  new MarketplaceConfigClientProvider(),
  isProdStage()
    ? {
        load: () => ({
          documents: marketplaceConfigProdDocuments,
          exactQueries: marketplaceConfigProdExactQueries,
          hierarchicalFallbackQueries: marketplaceConfigProdHfQueries,
        }),
      }
    : {
        load: () => ({
          documents: marketplaceConfigDevoDocuments,
          exactQueries: marketplaceConfigDevoExactQueries,
          hierarchicalFallbackQueries: marketplaceConfigDevoHfQueries,
        }),
      }
);

const countryCodeToMarketplaceIdClient = configManager.createClient(
  new CountryCodeToMarketplaceIdMapClientProvider(),
  isProdStage()
    ? {
        load: () => ({
          documents: countryCodeToMarketplaceIdProdDocuments,
          exactQueries: countryCodeToMarketplaceIdProdExactQueries,
          hierarchicalFallbackQueries: countryCodeToMarketplaceIdProdHfQueries,
        }),
      }
    : {
        load: () => ({
          documents: countryCodeToMarketplaceIdDevoDocuments,
          exactQueries: countryCodeToMarketplaceIdDevoExactQueries,
          hierarchicalFallbackQueries: countryCodeToMarketplaceIdDevoHfQueries,
        }),
      }
);

export const getCountryCode = (
  obfuscatedMarketplaceId: string
): string | null => {
  return (
    marketplaceToCountryCodeClient.getMarketplace(
      new MarketplaceConfigContext(obfuscatedMarketplaceId)
    )?.defaultCountryCode ?? null
  );
};

export const getPrimaryDomainName = (
  obfuscatedMarketplaceId: string
): string | null => {
  return (
    marketplaceToCountryCodeClient.getMarketplace(
      new MarketplaceConfigContext(obfuscatedMarketplaceId)
    )?.primaryDomainName ?? null
  );
};

export const getMarketplaceId = (countryCode: string): string | null => {
  return countryCodeToMarketplaceIdClient.getObfuscatedMarketplaceId(
    new CountryCodeToMarketplaceIdMapContext("retail", countryCode)
  );
};
